import { render } from "./SelectedPaymentCard.vue?vue&type=template&id=40504af6"
import script from "./SelectedPaymentCard.vue?vue&type=script&lang=js"
export * from "./SelectedPaymentCard.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src1700309314/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__